const PlayerFightPowerTable = ({items}) => {

    const getPlayerBadgeByPos = (pos) => {
        switch (parseInt(pos)) {
            case 1:
                return (<div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3">
                    <i className="fas fa-crown text-blue-500"></i>
                </div>);
            case 2:
                return (<div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center mr-3">
                    <i className="fas fa-medal text-gray-500"></i>
                </div>);
            case 3:
                return (<div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center mr-3">
                    <i className="fas fa-award text-yellow-500"></i>
                </div>);
            default:
                return (<div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center mr-3">
                    <i className="fas fa-user text-blue-400"></i>
                </div>);
        }
    };

    return (
        <>
            {
                items.map((item) => (
                    <div className="rank-item grid grid-cols-12 hover:bg-gray-50">
                        <div className="col-span-1 py-4 px-4 flex items-center justify-center">
                            {
                                item.rank <= 3 ? (
                                    <div
                                        className="rank-number w-8 h-8 rounded-full flex items-center justify-center text-white font-bold">
                                        {item.rank}
                                    </div>
                                ) : (
                                    <div
                                        className="w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold">{ item.rank }</div>
                                )
                            }
                        </div>
                        <div className="col-span-6 py-4 px-4 flex items-center">
                            {
                                getPlayerBadgeByPos(item.rank)
                            }
                            <div>
                                <div className="font-medium text-gray-800">{ item.character_name }</div>
                                <div className="text-xs text-gray-500">{ item.server.name }</div>
                            </div>
                        </div>
                        <div
                            className="col-span-2 py-4 px-4 text-center text-sm text-gray-700 flex items-center justify-center">
                            {
                                item.consortia_name === "" ? (
                                    <span
                                        className="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded">Sem associação</span>
                                ) : (
                                    <span
                                        className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded">{item.consortia_name}</span>
                                )
                            }
                        </div>
                        <div className="col-span-2 py-4 px-4 text-center text-sm font-medium text-gray-800">Lv.
                            { item.grade }
                        </div>
                        {/*<div className="col-span-1 py-4 px-4 text-center text-yellow-500">*/}
                        {/*    <i className="fas fa-gem"></i>*/}
                        {/*</div>*/}
                    </div>
                ))
            }
        </>
    );
};

export default PlayerFightPowerTable;